module.exports = "<div ng-form=$ctrl.inputForm> <input type=text class=form-control uib-datepicker-popup=dd.MM.yyyy name=dateInput ng-model=$ctrl.date ng-model-options=\"{timezone: '+0000'}\" is-open=$ctrl.isOpen ng-click=$ctrl.open() datepicker-options=$ctrl.options ng-required=$ctrl.mandatory datepicker-template-url=app/widgets/datepicker/datepicker.html datepicker-popup-template-url=app/widgets/datepicker/popup.html> <app-widgets-requirederror ng-show=$ctrl.inputForm.dateInput.$error.required></app-widgets-requirederror> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/datepicker/partial.html
// module id = 540
// module chunks = 0